module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "SlineDashboardpdf",
    attrs: {
      "id": "SlineDashboardpdf"
    }
  }, [_c('section', {
    staticClass: "dashboard"
  }, [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.showDash == true) ? _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard w-100 d-block",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px",
      "height": "auto !important"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "10"
    }
  }, [_c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("FF Shipping Line Exp Dashboard")])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-navbar-nav', {
    staticClass: "pull-right mr-auto"
  }, [_c('b-nav-form', [_c('b-button', {
    on: {
      "click": _vm.filterClear
    }
  }, [_vm._v("Clear")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-1",
    attrs: {
      "variant": "outline-info"
    },
    on: {
      "click": _vm.getPDF
    }
  }, [_c('i', {
    staticClass: "fa fa-cloud-download",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-card', [_c('b-row', {
    staticClass: "mt-2"
  }, [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Date")]), _vm._v(" "), _c('date-range-picker', {
    attrs: {
      "opens": _vm.openLeft,
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale
    },
    on: {
      "update": _vm.getShippingLineData
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Client")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllClientList'],
      "id": "clientNamenew",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Client Name",
      "isDisabled": _vm.$sessionsStorage.get('designation') != 'Admin' ? true : false
    },
    on: {
      "input": _vm.getShippingLineData
    },
    model: {
      value: (_vm.Filter.clientIdFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "clientIdFilter", $$v)
      },
      expression: "Filter.clientIdFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Shipping Line")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllShippingLineList'],
      "option-value": "shippingId",
      "option-text": "shippingLine",
      "placeholder": "Select Shipping Line",
      "isDisabled": _vm.$sessionsStorage.get('designation') != 'Admin' ? true : false
    },
    on: {
      "input": _vm.getShippingLineData
    },
    model: {
      value: (_vm.Filter.shippingLineFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "shippingLineFilter", $$v)
      },
      expression: "Filter.shippingLineFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Branch")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllBranchList'],
      "id": "branchfilter",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "All",
      "isDisabled": _vm.$sessionsStorage.get('designation') != 'Admin' ? true : false
    },
    on: {
      "input": _vm.getShippingLineData
    },
    model: {
      value: (_vm.Filter.branchfilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "branchfilter", $$v)
      },
      expression: "Filter.branchfilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("POR")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllPORList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select POR"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOR');
        _vm.getShippingLineData();
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOR')
      }
    },
    model: {
      value: (_vm.Filter.PORfilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "PORfilter", $$v)
      },
      expression: "Filter.PORfilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("POD")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.getPortDischargeList.length > 0 ? _vm.getPortDischargeList : _vm.$store.getters['common/getAllPODList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select POD"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'Sea_Port_NonIndia', 'getPortDischargeList');
        _vm.getShippingLineData();
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'Sea_Port_NonIndia', 'getPortDischargeList')
      }
    },
    model: {
      value: (_vm.Filter.PODfilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "PODfilter", $$v)
      },
      expression: "Filter.PODfilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("POL")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllPOLList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select POL"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOD');
        _vm.getShippingLineData();
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOD')
      }
    },
    model: {
      value: (_vm.Filter.POLfilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "POLfilter", $$v)
      },
      expression: "Filter.POLfilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("FPOD")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllLocationDetailsFinalList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Final Port of Discharge"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOD');
        _vm.getShippingLineData();
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOD')
      }
    },
    model: {
      value: (_vm.Filter.FPODfilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "FPODfilter", $$v)
      },
      expression: "Filter.FPODfilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Container Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllContainerTypeList'],
      "option-value": "containerTypeId",
      "option-text": "containerType",
      "placeholder": "Select Container Type"
    },
    on: {
      "input": _vm.getShippingLineData
    },
    model: {
      value: (_vm.Filter.containerTypeFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "containerTypeFilter", $$v)
      },
      expression: "Filter.containerTypeFilter"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "gutr mt-3"
  }, [(
    _vm.TotalShippedContEXP != 0 ||
    _vm.Tot20STDTUESTypeCount != 0 ||
    _vm.Tot40STDTUESTypeCount != 0
  ) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xl-3 col-sm-6 grid-margin stretch-card mb-2"
  }, [_c('div', {
    staticClass: "card card-statistics formCardDash"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between flex-wrap"
  }, [_c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h6', {
    staticClass: "card-title"
  }, [_vm._v("TOT. CONTAINERS TEUS EXP")]), _vm._v(" "), _c('div', {
    staticClass: "fluid-container"
  }, [_c('table', {
    staticClass: "table mb-0"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Execution")]), _vm._v(" "), _c('td', [_vm._v("CONTAINERS")]), _vm._v(" "), _c('td', [_vm._v("TEUS")])]), _vm._v(" "), _c('tr', [_c('td', [_c('h4', {
    staticClass: "card-title font-weight-bold mb-0"
  }, [_vm._v("\n                                    " + _vm._s(_vm.totalExec) + "\n                                  ")])]), _vm._v(" "), _c('td', [_c('h4', {
    staticClass: "card-title font-weight-bold mb-0"
  }, [_vm._v("\n                                    " + _vm._s(_vm.TotalShippedContEXP) + "\n                                  ")])]), _vm._v(" "), _c('td', [_c('h4', {
    staticClass: "card-title font-weight-bold mb-0"
  }, [_vm._v("\n                                    " + _vm._s(_vm.TotalShippedContEXPTUES) + "\n                                  ")])])])])])])])])]), _vm._v(" "), _c('div', [_c('md-icon', {
    staticClass: "md-size-1x"
  }, [_vm._v("import_export")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "card mt-2"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between flex-wrap"
  }, [_c('div', [_c('h6', {
    staticClass: "card-title"
  }, [_vm._v("TOT. TYPE OF CONTAINER EXP")]), _vm._v(" "), _c('div', {
    staticClass: "fluid-container"
  }, [_c('span', {
    staticClass: "card-title font-weight-bold mb-0"
  }, [_vm._v("20 = " + _vm._s(_vm.Tot20STDTypeCount))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "card-title font-weight-bold mb-0"
  }, [_vm._v("40 = " + _vm._s(_vm.Tot40STDTypeCount))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "card-title font-weight-bold mb-0"
  }, [_vm._v("\n                        LCL CONTAINERS :\n                        " + _vm._s(_vm.TotLCL_Container_TotalShippedCont) + "\n                      ")])])]), _vm._v(" "), _c('div', [_c('md-icon', {
    staticClass: "md-size-1x"
  }, [_vm._v("import_export")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "card mt-2"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between flex-wrap"
  }, [_c('div', [_c('h6', {
    staticClass: "card-title"
  }, [_vm._v("TOTAL TEUS")]), _vm._v(" "), _c('div', {
    staticClass: "fluid-container"
  }, [_c('span', {
    staticClass: "font-weight-bold mb-0"
  }, [_vm._v("\n                        " + _vm._s(_vm.Tot20STDTypeCount) + " * 1 =\n                        " + _vm._s(_vm.Tot20STDTUESTypeCount) + "\n                      ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "font-weight-bold mb-0"
  }, [_vm._v("\n                        " + _vm._s(_vm.Tot40STDTypeCount) + " * 2 =\n                        " + _vm._s(_vm.Tot40STDTUESTypeCount) + "\n                      ")]), _vm._v("\n                        \n                      "), _c('span', {
    staticClass: "card-title font-weight-bold mb-0"
  }, [_c('b-badge', {
    attrs: {
      "variant": "primary"
    }
  }, [_vm._v(_vm._s(_vm.Tot20STDTUESTypeCount))]), _vm._v("+\n                        "), _c('b-badge', {
    attrs: {
      "variant": "primary"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.Tot40STDTUESTypeCount) + " ")]), _vm._v("=\n                        "), _c('b-badge', {
    attrs: {
      "variant": "danger"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.Tot20STDTUESTypeCount + _vm.Tot40STDTUESTypeCount) + "\n                        ")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "font-weight-bold mb-0"
  }, [_vm._v("\n                        LCL CONTAINERS :\n                        " + _vm._s(_vm.TotLCLTUES_Container_TotalShippedCont) + "\n                      ")])])]), _vm._v(" "), _c('div', [_c('md-icon', {
    staticClass: "md-size-1x"
  }, [_vm._v("import_export")])], 1)])])])]), _vm._v(" "), (_vm.totalExec != '0') ? _c('div', {
    staticClass: "col-xl-5 col-md-6 grid-margin stretch-card mt-2"
  }, [_c('div', {
    staticClass: "card card-statistics formCardDash"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between flex-wrap"
  }, [_c('div', [_c('h6', {
    staticClass: "card-title"
  }, [_vm._v("TOTAL CONTAINER TYPE EXP MODULES")]), _vm._v(" "), _c('div', {
    staticClass: "fluid-container"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chart"
    }
  }, [(_vm.showgraphsContainer == true) ? _c('apexchart', {
    staticClass: "mt-3",
    attrs: {
      "type": "pie",
      "width": "530",
      "options": _vm.chartOptions,
      "series": _vm.series
    }
  }) : _vm._e()], 1)])])])])]) : _vm._e(), _vm._v(" "), (
    _vm.seriesExpSlineClientGraph[0].data.length > 0 ||
    _vm.seriesExpSlineClientGraph[1].data.length > 0
  ) ? _c('div', {
    staticClass: "col-xl-12 col-md-12 grid-margin stretch-card mt-2"
  }, [_c('div', {
    staticClass: "card card-statistics formCardDash"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between flex-wrap"
  }, [_c('div', [_c('h6', {
    staticClass: "card-title"
  }, [_vm._v("\n                      TOTAL TEUS EXP MODULES - " + _vm._s(_vm.graphSlineName) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "fluid-container"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chart"
    }
  }, [(
    _vm.DateRangeContexecDataCount.length > 0 &&
    (_vm.seriesExpSlineClientGraph[0].data.length > 0 ||
      _vm.seriesExpSlineClientGraph[1].data.length > 0)
  ) ? _c('apexchart', {
    staticClass: "mt-3",
    attrs: {
      "type": "bar",
      "height": "550",
      "width": "1000",
      "options": _vm.chartOptionsExpSlineClientGraph,
      "series": _vm.seriesExpSlineClientGraph
    }
  }) : _vm._e()], 1)])])])])]) : _vm._e(), _vm._v(" "), (_vm.getSlineClinteBasedData.length > 0) ? _c('div', {
    staticClass: "col-xl-12 col-md-12 grid-margin stretch-card mt-2"
  }, [_c('div', {
    staticClass: "card card-statistics formCardDash"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between flex-wrap"
  }, [(_vm.getSlineClinteBasedData) ? _c('table', {
    staticClass: "table table-bordered",
    attrs: {
      "id": "shiper"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("SN.")]), _vm._v(" "), _c('th', [_vm._v("Date Range")]), _vm._v(" "), _c('th', [_vm._v("Sline")]), _vm._v(" "), _c('th', [_vm._v("Execution")]), _vm._v(" "), _c('th', [_vm._v("Containers")]), _vm._v(" "), _c('th', [_vm._v("TEUS")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.getSlineClinteBasedData), function(item1, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.fromDate + " / " + item1.toDate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.shippingLine))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.allModuleIdCount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.ContainerCount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.alltues_count))])])
  }))]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.topBranchWiseContainerExportData > '0') ? _c('div', {
    staticClass: "col-xl-4 col-md-6 grid-margin stretch-card mt-2"
  }, [_c('div', {
    staticClass: "card card-statistics formCardDash"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between flex-wrap"
  }, [_c('div', [_c('h6', {
    staticClass: "card-title"
  }, [_vm._v("MOST EXP BRANCH WISE CONTAINERS")]), _vm._v(" "), _c('p', {
    staticClass: "card-description text-muted"
  }, [_vm._v("TOP 10 (BRANCH)")]), _vm._v(" "), _c('div', {
    staticClass: "fluid-container"
  }, [_c('table', {
    staticClass: "table mb-0"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("BRANCH")]), _vm._v(" "), _c('th', [_vm._v("CONTAINERS")]), _vm._v(" "), _c('th', [_vm._v("TEUS")])]), _vm._v(" "), _vm._l((_vm.topBranchWiseContainerExportData), function(item3, index) {
    return _c('tr', {
      key: index
    }, [(index < 10) ? _c('td', {
      staticClass: "pl-0"
    }, [_vm._v("\n                              " + _vm._s(item3.BranchWise) + "\n                            ")]) : _vm._e(), _vm._v(" "), (index < 10) ? _c('td', {
      staticClass: "pr-0"
    }, [_c('b-badge', {
      attrs: {
        "variant": "primary"
      }
    }, [_vm._v("\n                                " + _vm._s(item3.BranchContainerCount) + "\n                              ")])], 1) : _vm._e(), _vm._v(" "), (index < 10) ? _c('td', {
      staticClass: "pr-0"
    }, [_c('b-badge', {
      attrs: {
        "variant": "danger"
      }
    }, [_c('b', [_vm._v("\n                                  " + _vm._s(item3.BranchContainerTues_Count) + "\n                                ")])])], 1) : _vm._e()])
  })], 2)]), _vm._v(" "), _c('b-collapse', {
    staticClass: "mt-2",
    attrs: {
      "id": "collapse-branchvisible"
    },
    model: {
      value: (_vm.branchvisible),
      callback: function($$v) {
        _vm.branchvisible = $$v
      },
      expression: "branchvisible"
    }
  }, [_c('table', {
    staticClass: "table mb-0"
  }, [_c('tr', {
    staticStyle: {
      "color": "#fff"
    }
  }, [_c('th', [_vm._v("BRANCH")]), _vm._v(" "), _c('th', [_vm._v("CONTAINERS")]), _vm._v(" "), _c('th', [_vm._v("TEUS")])]), _vm._v(" "), _c('tbody', _vm._l((_vm.topBranchWiseContainerExportData), function(item3, index) {
    return _c('tr', {
      key: index
    }, [(index >= 10) ? _c('td', {
      staticClass: "pl-0"
    }, [_vm._v("\n                                " + _vm._s(item3.BranchWise) + "\n                              ")]) : _vm._e(), _vm._v(" "), (index >= 10) ? _c('td', {
      staticClass: "pr-0"
    }, [_c('b-badge', {
      attrs: {
        "variant": "primary"
      }
    }, [_vm._v("\n                                  " + _vm._s(item3.BranchContainerCount) + "\n                                ")])], 1) : _vm._e(), _vm._v(" "), (index >= 10) ? _c('td', {
      staticClass: "pr-0"
    }, [_c('b-badge', {
      attrs: {
        "variant": "danger"
      }
    }, [_c('b', [_vm._v("\n                                    " + _vm._s(item3.BranchContainerTues_Count) + "\n                                  ")])])], 1) : _vm._e()])
  }))])]), _vm._v(" "), (_vm.topBranchWiseContainerExportData.length > 10) ? _c('span', {
    class: _vm.branchvisible ? null : 'collapsed error',
    attrs: {
      "aria-expanded": _vm.branchvisible ? 'true' : 'false',
      "aria-controls": "collapse-branchvisible"
    },
    on: {
      "click": _vm.branchvisibleFun
    }
  }, [_vm._v("VIEW MORE")]) : _vm._e()], 1)])])])])]) : _vm._e(), _vm._v(" "), (
    _vm.top10ContainerTypeExportData.length > '0' &&
    _vm.top10BranchesExportData.length > 0
  ) ? _c('div', {
    staticClass: "col-xl-8 col-md-8 grid-margin stretch-card mt-2"
  }, [_c('div', {
    staticClass: "card card-statistics formCardDash"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between flex-wrap"
  }, [_c('div', [_c('h6', {
    staticClass: "card-title"
  }, [_vm._v("\n                      MOST EXP Sline WISE TYPE BASED CONTAINERS\n                    ")]), _vm._v(" "), _c('p', {
    staticClass: "card-description text-muted"
  }, [_vm._v("TOP 10 (Branch)")]), _vm._v(" "), _c('div', {
    staticClass: "fluid-container",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.totalHtmlCont)
    }
  }, [_vm._v("\n                        " + _vm._s(this.totalHtmlCont) + "\n                        ")])])])])])])]) : _vm._e(), _vm._v(" "), (
    _vm.top10ContainerTypeExportData.length > '0' &&
    _vm.top10ClientExportData.length > 0
  ) ? _c('div', {
    staticClass: "col-xl-8 col-md-8 grid-margin stretch-card mt-2"
  }, [_c('div', {
    staticClass: "card card-statistics formCardDash"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between flex-wrap"
  }, [_c('div', [_c('h6', {
    staticClass: "card-title"
  }, [_vm._v("\n                      MOST EXP Client WISE TYPE BASED CONTAINERS\n                    ")]), _vm._v(" "), _c('p', {
    staticClass: "card-description text-muted"
  }, [_vm._v("TOP 10 (Client)")]), _vm._v(" "), _c('div', {
    staticClass: "fluid-container",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.totalSlineHtmlCont)
    }
  }, [_vm._v(_vm._s(this.totalSlineHtmlCont))])])])])])])]) : _vm._e(), _vm._v(" "), (
    _vm.top10ContainerTypeExportData.length > '0' &&
    _vm.top10PORWiseBaseContainerTyperow.length > 0
  ) ? _c('div', {
    staticClass: "col-xl-8 col-md-8 grid-margin stretch-card mt-2"
  }, [_c('div', {
    staticClass: "card card-statistics formCardDash"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between flex-wrap"
  }, [_c('div', [_c('h6', {
    staticClass: "card-title"
  }, [_vm._v("MOST EXP POR WISE TYPE BASED CONTAINERS")]), _vm._v(" "), _c('p', {
    staticClass: "card-description text-muted"
  }, [_vm._v("TOP 10 (POR)")]), _vm._v(" "), _c('div', {
    staticClass: "fluid-container",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.PORHtmlCont)
    }
  }, [_vm._v(_vm._s(this.PORHtmlCont))])])])])])])]) : _vm._e(), _vm._v(" "), (
    _vm.top10ContainerTypeExportData.length > '0' &&
    _vm.top10POLWiseBaseContainerTyperow.length > 0
  ) ? _c('div', {
    staticClass: "col-xl-8 col-md-8 grid-margin stretch-card mt-2"
  }, [_c('div', {
    staticClass: "card card-statistics formCardDash"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between flex-wrap"
  }, [_c('div', [_c('h6', {
    staticClass: "card-title"
  }, [_vm._v("MOST EXP POL WISE TYPE BASED CONTAINERS")]), _vm._v(" "), _c('p', {
    staticClass: "card-description text-muted"
  }, [_vm._v("TOP 10 (POL)")]), _vm._v(" "), _c('div', {
    staticClass: "fluid-container",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.POLHtmlCont)
    }
  }, [_vm._v(_vm._s(this.POLHtmlCont))])])])])])])]) : _vm._e()]) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xl-12 col-sm-12 grid-margin stretch-card mb-2 text-center"
  }, [_c('div', {
    staticClass: "card card-statistics formCardDash"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xl-4 col-sm-12 grid-margin"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xl-4 col-sm-12 grid-margin"
  }, [_c('center', [_c('h6', {
    staticClass: "card-title error text-center"
  }, [_vm._v("Data Not Found !")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xl-4 col-sm-12 grid-margin"
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row gutr"
  })], 1) : _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-navbar', {
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "info"
    }
  }, [(_vm.showDash == false) ? _c('b-navbar-brand', [(_vm.employeeName != '') ? _c('h4', {
    staticClass: "page-title"
  }, [_vm._v("\n            Welcome\n            "), _c('small', [_vm._v(_vm._s(_vm.employeeName))])]) : _vm._e()]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop22",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55637802","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/dashboard/ffSlineDashboard.vue
// module id = 2641
// module chunks = 0